import { ExperimentalDivider, ExperimentalPanel, Loader, Stacked } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@/components/head/PageTitle';
import { AppShellContents } from '@/components/layout/AppShell';
import { EmptyTopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';
import { HomeGreeting } from './HomeGreeting';
import { HomeSearch } from './HomeSearch';
import { HomeSection } from './HomeSection';
import { QuickStart } from './QuickStart';
import { RecentlyVisited } from './RecentlyVisited';

export const HomePage = () => {
  const { t } = useTranslation('home');

  return (
    <>
      <PageTitle>{t('title')}</PageTitle>
      <AppShellContents
        topBar={
          <EmptyTopBar>
            <TopBarHeading>{t('title')}</TopBarHeading>
          </EmptyTopBar>
        }
      >
        <ExperimentalPanel background="primary" isFullHeight padding="small">
          <ExperimentalPanel background="tertiary" isCondensedOnMobile isFullHeight padding="huge">
            <Stacked direction="column" gap="medium">
              <HomeSection>
                <Stacked direction="column" alignItems="center">
                  <HomeGreeting />
                </Stacked>
              </HomeSection>
              <HomeSection>
                <HomeSearch />
              </HomeSection>
              <HomeSection>
                <RecentlyVisited />
              </HomeSection>
              <ExperimentalDivider />
              <HomeSection
                fallback={
                  <Stacked justifyContent="center">
                    <Loader />
                  </Stacked>
                }
              >
                <QuickStart />
              </HomeSection>
            </Stacked>
          </ExperimentalPanel>
        </ExperimentalPanel>
      </AppShellContents>
    </>
  );
};
